export default "__VITE_ASSET__c1961475__"